import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#4A148C', // Deep Purple (Cuaresma)
                secondary: '#FFC107', // Amber/Gold
                accent: '#9C27B0',
                error: '#D32F2F',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                dark: '#212121'
            },
            dark: {
                primary: '#7E57C2',
                secondary: '#FFCA28',
                accent: '#B39DDB',
                error: '#EF5350',
                info: '#42A5F5',
                success: '#66BB6A',
                warning: '#FFCA28',
            }
        },
    },
});
